import React from 'react';
import './Home.css';
import WelcomeMessage from '../../components/WelcomeMessage/WelcomeMessage';
import Button from '../../components/Button/Button';
import phoneBg from '../../assets/phone.png';
import PhoneInfoBox from '../../components/PhoneInfoBox/PhoneInfoBox';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../../LanguageProvider';

const Home = () => {
  const { getTranslation } = useLanguage();
  const navigate = useNavigate();

  return (
    <div className="homeContainer">
      <WelcomeMessage message={getTranslation("deliverReceiveAndTrack")} />

      <div className="buttonContainer">
        <Button
          label={getTranslation("signIn")}
          variant="primary"
          style={{ width: '50%' }}
          onClick={() => navigate('/login-phone')}
        />

        <a href="tel:08502140044" style={{ width: '50%' }}>
          <Button
            label={getTranslation("contactUs")}
            variant="outlined"
            style={{ width: '100%' }}
          />
        </a>
      </div>


      <PhoneInfoBox
        style={{ position: 'absolute', bottom: 291, left: 9, zIndex: 2 }}
        number="01"
        message={getTranslation("loginToAvmServicesAndCreateRequest")}
        side="left"
      />

      <PhoneInfoBox
        style={{ position: 'absolute', bottom: 200, right: 11, zIndex: 2 }}
        number="02"
        message={getTranslation("selectServiceAndTime")}
        side="right"
      />

      <PhoneInfoBox
        style={{ position: 'absolute', bottom: 109, left: 9, zIndex: 2 }}
        number="03"
        message={getTranslation("trackAndPerformServices")}
        side="left"
      />

      {/* Alt kısma yapışık phoneBg resmi */}
      <div className="phoneContainer">
        <img src={phoneBg} alt="Phone Background" />
      </div>



    </div>
  );
};

export default Home;
